<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  location: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['remove']);

const displayTitle = computed(() => {
  if (props.location.name) return props.location.name;
  return `${props.location.latitude}, ${props.location.longitude}`;
});

const displaySubtitle = computed(() => {
  if (props.location.address) return props.location.address;
  if (props.location.name) {
    return `${props.location.latitude}, ${props.location.longitude}`;
  }
  return '';
});
</script>

<template>
  <div
    class="flex items-center gap-2 p-2 mb-2 rounded-lg bg-n-slate-3 border border-n-weak"
  >
    <span class="flex-shrink-0 text-lg i-ph-navigation-arrow-fill text-[#0D9B8A]" />
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-n-slate-12">
        {{ displayTitle }}
      </p>
      <p
        v-if="displaySubtitle"
        class="text-xs truncate text-n-slate-11"
      >
        {{ displaySubtitle }}
      </p>
    </div>
    <Button
      ghost
      slate
      sm
      icon="i-ph-x"
      @click="emit('remove')"
    />
  </div>
</template>
